import React from 'react';
import { GeoData } from '@wix/wix-common-aspects';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './CbdBanner.scss';

type CbdBannerProps = {
  geoData: GeoData;
  dataHook?: string;
};

const getCBDBannerContent = (geoData: GeoData) => {
  if (geoData?.['2lettersCountryCode']?.toLowerCase() === 'us') {
    return { cta: 'banner.cbd.usa.cta', text: 'banner.cbd.usa.body' };
  }
  return { cta: 'banner.cbd.other.cta', text: 'banner.cbd.other.body' };
};

export const CbdBanner: React.FC<CbdBannerProps> = ({ dataHook, geoData }) => {
  const { t } = useTranslation();

  const { cta, text } = getCBDBannerContent(geoData);

  return (
    <a href={t('banner.cbd.link')} target="_blank" className={s.bannerBody} data-hook={dataHook}>
      <span className={s.text}>{t(text)}</span>
      <span className={s.cta}>{t(cta)}</span>
    </a>
  );
};
